import { useEffect, useState } from 'react';
import { RemoteResourceV3 } from '../api/RemoteResourceV3';

type AsyncGetter<T> = () => Promise<T> | T;
type Callback<T> = (value: T) => any;

export function useRemoteResource<T>(
    getter: AsyncGetter<T>,
    onReload: Callback<T> = null
): [RemoteResourceV3<T>, () => any] {
    const [resource, setResource] = useState(RemoteResourceV3.loading());
    const reload = async () => {
        setResource(RemoteResourceV3.loading());
        const value = await getter();
        setResource(RemoteResourceV3.of(value));
        if (onReload) {
            onReload(value);
        }
    };
    useEffect(() => {
        reload();
    }, []);
    return [resource, reload];
}
